import { ROUTE_NAME } from '@/lib/constant';
import Loading from '@/pages/extra/loading.vue';
import { Route } from 'vue-router';
import store from '@/store';
import { Toast } from 'vant';
export default [
    {
        name: 'summary',
        path: '/summary', // 首页跳转判断
        beforeEnter(to: Route, from: Route, next: any) {
            const activityId = 1;
            const basicInfo = store.state.activity.basicInfo[activityId];
            if (!basicInfo!.joined) {
                Toast('您还没有报名，暂时无法查看战报');
                next(false);
                return;
            }
            const userId = store.state.user.basicInfo!.id;

            next({
                name: ROUTE_NAME.SUMMARY_HUNDRED_10,
                params: {
                    userId,
                },
                replace: true,
            });
        },
    },
    {
        path: '/report/hundred10/:userId?',
        name: ROUTE_NAME.REPORT_HUNDRED_10,
        meta: {
            title: '完赛证书',
            scrollBehavior: 'top',
            auth: true,
        },
        component: () => ({
            component: import(/* webpackChunkName: "summary" */ '@/pages/summary/report.vue'),
            loading: Loading,
        }),
    },
    {
        path: '/report/hundred11/:userId?',
        name: ROUTE_NAME.REPORT_HUNDRED_11,
        meta: {
            title: '完赛证书',
            scrollBehavior: 'top',
            auth: true,
        },
        component: () => ({
            component: import(/* webpackChunkName: "summary" */ '@/pages/summary/report11.vue'),
            loading: Loading,
        }),
    },
    {
        path: '/report/hundred12/:userId?',
        name: ROUTE_NAME.REPORT_HUNDRED_12,
        meta: {
            title: '完赛证书',
            scrollBehavior: 'top',
            auth: true,
        },
        component: () => ({
            component: import(/* webpackChunkName: "summary" */ '@/pages/summary/report12.vue'),
            loading: Loading,
        }),
    },
    {
        path: '/summary/hundred10/:userId?',
        name: ROUTE_NAME.SUMMARY_HUNDRED_10,
        meta: {
            title: '第10届百日跑战报',
            scrollBehavior: 'top',
            auth: true,
        },
        component: () => ({
            component: import(/* webpackChunkName: "summary" */ '@/pages/summary/hundred10.vue'),
            loading: Loading,
        }),
    },
];
